import React from 'react';
import { Outlet } from 'react-router-dom';

export const OrderRoot: React.FunctionComponent = function () {
    return <Outlet />;
};
